import { PAGE_URLS } from '../../constants/hrefLinks';
import './style.scss';

interface AppFooterProps {
	activeIndex: number
}

function AppFooter({activeIndex}: AppFooterProps) {

	return (
		<div className="app-footer">
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 0 ? '/imgs/icons/footer/icon-footer-explore-active.svg' : '/imgs/icons/footer/icon-footer-explore-inactive.svg'}
					alt='Explore icon'
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 1 ? '/imgs/icons/footer/icon-footer-community-active.svg' : '/imgs/icons/footer/icon-footer-community-inactive.svg'}
					alt='Community icon'
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 2 ? '/imgs/icons/footer/icon-footer-marketplace-active.svg' : '/imgs/icons/footer/icon-footer-marketplace-inactive.svg'}
					alt='Market place icon'
				/>
			</div>
			<div className='app-footer-button'>
				<img
					className='app-footer-button-img'
					src={activeIndex === 3 ? '/imgs/icons/footer/icon-footer-lessons-active.svg' : '/imgs/icons/footer/icon-footer-lessons-inactive.svg'}
					alt='Lesson icon'
				/>
			</div>
			<div 
				className='app-footer-button'
				onClick={() => {
					window.location.replace(`${PAGE_URLS.DASHBOARD_CUSTOMER}`)
				}}
			>
				<img
					className='app-footer-button-img'
					src={activeIndex === 4 ? '/imgs/icons/footer/icon-footer-profile-active.svg' : '/imgs/icons/footer/icon-footer-profile-inactive.svg'}
					alt='Profile icon'
				/>
			</div>
		</div>
	)
}

export default AppFooter